interface KpiCardProps {
  label: string
  value: string
  subtitle?: string
  accent?: boolean
  warning?: boolean
}

export function KpiCard({ label, value, subtitle, accent, warning }: KpiCardProps) {
  return (
    <div
      style={{
        background: 'rgba(255,255,255,0.8)',
        border: '1px solid var(--border)',
        borderRadius: '12px',
        padding: '20px',
        flex: 1,
        minWidth: '180px',
      }}
    >
      <div
        style={{
          fontFamily: 'var(--sans)',
          fontSize: '12px',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: 'var(--ink-muted)',
          marginBottom: '8px',
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontFamily: 'var(--serif)',
          fontSize: '28px',
          fontWeight: 600,
          color: warning ? '#dc2626' : accent ? 'var(--accent)' : 'var(--ink)',
        }}
      >
        {value}
      </div>
      {subtitle && (
        <div
          style={{
            fontFamily: 'var(--sans)',
            fontSize: '12px',
            color: 'var(--ink-muted)',
            marginTop: '4px',
          }}
        >
          {subtitle}
        </div>
      )}
    </div>
  )
}
